/** Numeric guard for degenerate scales and denominators across the insight detectors. */
export const EPSILON = 1e-9;
